import React from "react";

export default function SpotifyIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#1DB954"
        d="M8.5 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm3.669 11.538a.498.498 0 0 1-.686.165c-1.879-1.147-4.243-1.407-7.028-.77a.499.499 0 0 1-.222-.973c3.048-.696 5.662-.397 7.77.892.235.144.31.451.166.686Zm.979-2.178a.624.624 0 0 1-.858.205c-2.15-1.321-5.428-1.704-7.972-.932a.625.625 0 0 1-.362-1.194c2.905-.881 6.517-.454 8.986 1.063.294.181.386.565.206.858Zm.084-2.268C10.654 5.56 6.4 5.419 3.938 6.166a.748.748 0 1 1-.434-1.432c2.825-.857 7.523-.692 10.492 1.07a.747.747 0 1 1-.764 1.288Z"
      />
    </svg>
  );
}
